'use client'
import { Table, TableRow, TableHeader, TableCell, TextArea, CheckboxItem, ColorButton, ReplyMessage } from "@/components/ui";
import { defaultFeedback, FeedbackIdResponseType } from "@/types";
import { useActionState, useEffect, useState } from "react";
import { getFeedbackId, updateFeedbackForm } from "@/app/api";
import { SquareCheck, Text } from "@/assets/icons";
import { useRouter } from "next/navigation";
import Form from "next/form";

export function UpdateFeedback({ id }: { id: string }) {
    const [feedbackData, setFeedbackData] = useState<FeedbackIdResponseType>();

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getFeedbackId(id)
                if (response !== undefined) {
                    setFeedbackData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o retorno: ', e)
            }
        }

        fetchUser()
    }, [id]);

    const feedback = feedbackData || defaultFeedback;

    const [state, formAction, pending] = useActionState(updateFeedbackForm, {
        values: { id: feedback.id, content: '', status: '' },
        errors: {},
        message: '',
    });

    const router = useRouter();
    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);
    };

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableHeader>Autor</TableHeader>
                            <TableHeader>Email do autor</TableHeader>
                            <TableHeader>Status</TableHeader>
                            <TableHeader>Data do envio</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{feedback.sequence}</TableCell>
                            <TableCell>{feedback.content}</TableCell>
                            <TableCell>
                                {feedback.user?.name ? 'Usuário' : 'Visitante'} - {feedback.user?.name || feedback.visitor?.name}
                            </TableCell>
                            <TableCell>
                                {feedback.user?.email || feedback.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableCell>
                                {feedback.status === 'PENDING' ? 'Pendente'
                                    : feedback.status === 'APPROVED' ? "Aprovado"
                                        : feedback.status === 'REJECTED' ? 'Rejeitado'
                                            : feedback.status === 'FLAGGED' ? 'Sinalizado'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableCell>{new Date(feedback.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{feedback.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>

            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableCell>{feedback.sequence}</TableCell>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableCell>{feedback.content}</TableCell>
                            <TableHeader>Autor</TableHeader>
                            <TableCell>
                                {feedback.user?.name ? 'Usuário' : 'Visitante'} - {feedback.user?.name || feedback.visitor?.name}
                            </TableCell>
                            <TableHeader>Email do autor</TableHeader>
                            <TableCell>
                                {feedback.user?.email || feedback.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableHeader>Status</TableHeader>
                            <TableCell>
                                {feedback.status === 'PENDING' ? 'Pendente'
                                    : feedback.status === 'APPROVED' ? "Aprovado"
                                        : feedback.status === 'REJECTED' ? 'Rejeitado'
                                            : feedback.status === 'FLAGGED' ? 'Sinalizado'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableHeader>Data do envio</TableHeader>
                            <TableCell>{new Date(feedback.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{feedback.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>

            </div>

            <Form action={formAction} className="flex flex-col gap-3">

                <input type="hidden" name="id" defaultValue={feedback.id} required />

                {/* feedback */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="content">Conteúdo do Retorno</label>
                </div>
                <TextArea name="content" id="content"
                    defaultValue={feedback.content || state?.values?.content}
                    placeholder="Conteúdo do Retorno" />
                {state?.errors?.content && <p>{state.errors.content}</p>}

                {/* observation */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="observation">Observação</label>
                </div>
                <TextArea name="observation" id="observation"
                    defaultValue={feedback.observation || state?.values?.observation}
                    placeholder="Observação" />
                {state?.errors?.observation && <p>{state.errors.observation}</p>}

                {/* status */}

                <div className="flex gap-2 items-center">
                    <SquareCheck className="size-4" />
                    <label htmlFor="status">Status</label>
                </div>
                <div className="flex flex-wrap gap-5">
                    <CheckboxItem name="status"
                        value="pending" label="Pendente"
                        defaultChecked={feedback.status === 'PENDING' || state?.values?.status === 'pending'}
                    />

                    <CheckboxItem name="status"
                        value="approved" label="Aprovado"
                        defaultChecked={feedback.status === 'APPROVED' || state?.values?.status === 'approved'}
                    />


                    <CheckboxItem name="status"
                        value="rejected" label="Rejeitado"
                        defaultChecked={feedback.status === 'REJECTED' || state?.values?.status === 'rejected'}
                    />


                    <CheckboxItem name="status"
                        value={"flagged"} label="Sinalizado"
                        defaultChecked={feedback.status === 'FLAGGED' || state?.values?.status === 'flagged'}
                    />

                </div>
                {state?.errors?.status && <p>{state.errors.status}</p>}

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending
                            ? 'Atualizando...'
                            : 'Atualizar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div>
    )
}